<ng-container *transloco="let t">
  <section
    class="featured-listing-details-card"
    [class.rtl]="rtlMode"
    [class.widescreen]="(biggerThan$ | async)?.sm">
    <app-product-json-ld [product]="product"></app-product-json-ld>
    <!--  @if (!(biggerThan$ | async)?.sm && (testProductPage$ | async) === 'ppVar2') {
      <h4 class="title-wrap">{{ product?.title || product?.model || '...' }}</h4>
    } -->
    <!-- space for the floating title -->
    @if ((product?.title?.length || 0) > 35 && product?.category !== 'LAPTOP') {
      <span class="fixed-space-16" aria-hidden="true"></span>
    }
    <popsy-gallery
      class="column expand gallery"
      [class.wide-mode]="product?.category === 'LAPTOP'"
      [pictures]="galleryPictures || []"
      [wideMode]="product?.category === 'LAPTOP'"></popsy-gallery>

    <!-- Discount Badge -->
    <app-featured-discount-badge
      [price]="product?.price?.amount"
      [originalPrice]="product?.originalPrice?.amount"
      class="badge-wrap"></app-featured-discount-badge>

    <span class="fixed-space-16" aria-hidden="true"></span>

    <section class="column popsy-card light-gray purchase">
      <!-- Purchase Info -->
      <app-featured-purchase-info-card [product]="product" [currency]="currency">
      </app-featured-purchase-info-card>

      <div
        class="flex align-center pointer"
        [class.p-0-16]="!(biggerThan$ | async)?.sm"
        [class.p-0-32]="(biggerThan$ | async)?.sm"
        (click)="isDescriptionExpanded = !isDescriptionExpanded">
        <strong>{{ t('label_description') }}</strong>
        <button class="popsy-button-icon expand">
          <popsy-icon-chevron-down
            class="icon fill-gray-01"
            [class.selected]="isDescriptionExpanded" />
        </button>
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>
      @if (isDescriptionExpanded) {
        <!-- HighLights -->
        <section class="banner">
          <app-featured-highlights></app-featured-highlights>
        </section>
        <!-- Specs Selector -->
        <app-featured-specs-selector [product]="product"></app-featured-specs-selector>
        <!-- COMES WITH -->
        @if (product?.category !== 'ACCESSORIES') {
          <div
            [class.p-0-16]="!(biggerThan$ | async)?.sm"
            [class.p-0-32]="(biggerThan$ | async)?.sm">
            <strong class="label text-gray-05">{{ t('label_cable') }}</strong>
            <span class="fixed-space-4" aria-hidden="true"></span>
            <div class="flex">
              <div class="card contains">
                <a class="link popsy-negative mid-gray flex">
                  <popsy-icon-spec-usb class="icon gray-dark"></popsy-icon-spec-usb>
                  <span class="fixed-space-8" aria-hidden="true"></span>
                  <span class="small gray-dark">{{ t('content_power') }}</span>
                </a>
              </div>
            </div>
            <span class="fixed-space-16" aria-hidden="true"></span>
          </div>
        }
      } @else {
        <section class="description not-visible">
          <app-featured-description-card
            [product]="product"></app-featured-description-card>
        </section>
      }
    </section>
  </section>
</ng-container>
